// redux/slices/usersSlice.ts

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

export interface Volunteer {
  id: number;
  userName: string;
  department: string;
  shortId: string;
}

interface UsersState {
  data: Volunteer[];
  loading: boolean;
  error: string | null;
}

const initialState: UsersState = {
  data: [],
  loading: false,
  error: null,
};

export const VolunteerValidation = createAsyncThunk(
  "volunteer/validateVolunteer",
  async (shortId: number | string | null, { rejectWithValue }) => {

    try {
      const response = await axiosInstance.get(`api/eventregistration/searchShortId/${shortId}`);
      return response.data as Volunteer[];
    } catch (error) {
      return rejectWithValue("Failed to fetch users");
    }
  },
);

const VolunteerValidationSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(VolunteerValidation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(VolunteerValidation.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(VolunteerValidation.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Something went wrong";
      });
  },
});

export default VolunteerValidationSlice.reducer;
